import React, { useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import useAsyncDataCourier from '../../../common/custom-hooks/useAsyncDataCourier';
import { GRID_MODE, TYPES, OPERATORS, CARD_MODE, removeFilters } from '../../../common/list-utils';
import MessageCourier from '../../../lib/MessageCourier';
import SystemClient from '../../../system/SystemClient';
import { ListColumnFilter } from '../../Common/list-entities/ListColumnFilter';
import { PlanillaPartidoProgramadoGridList } from './PlanillaPartidoProgramadoGridList';
import { routes } from '../../../common/routes';
import { Usuario } from '../../../system/Usuario/Usuario';
import { PlanillaPartido } from '../../../system/PlanillaPartido/PlanillaPartido';
interface IPlanillaPartidoProgramadoList {
  system: SystemClient;
  courier: MessageCourier;
  changeBlockUI: (state: boolean) => void;
  user: Usuario;
  setIsPartidoOnline: (p: boolean) => void;
  setPlanillaPartido: (p: PlanillaPartido | undefined) => void;
}

export const PlanillaPartidoProgramadoList = ({
  system,
  courier,
  changeBlockUI,
  user,
  setIsPartidoOnline,
  setPlanillaPartido,
}: IPlanillaPartidoProgramadoList) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [mode, setMode] = useState(GRID_MODE);
  const baseUrl = React.useMemo(() => {
    return system.getPartidoSystem().getBaseUrlForDatagridForProgramados();
  }, [system]); //chequear la dependencia
  const onItemClick = async (item: any) => {
    const id = item.par_id;
    setIsPartidoOnline(true);
    setPlanillaPartido(undefined);
    navigate(`${routes.planilla_partido_programado.route}/${id}`);
  };

  const RAMAS = [
    { key: '', text: 'Todos' },
    { key: 'M', text: 'Masculina' },
    { key: 'F', text: 'Femenina' },
  ];

  const quickFilters: ListColumnFilter[] = useMemo(() => {
    let ret: ListColumnFilter[] = [
      {
        quick: true,
        name: 'torneo_nombre',
        type: TYPES.INPUT,
        placeholder: t('Torneo'),
        operator: OPERATORS.CONTAINS,
      },

      {
        quick: true,
        name: 'categoria',
        type: TYPES.INPUT,
        placeholder: t('Categoría'),
        operator: OPERATORS.CONTAINS,
      },
      {
        quick: true,
        name: 'rama',
        type: TYPES.RADIO,
        contextForRadio: RAMAS,
        placeholder: t('Rama'),
        operator: OPERATORS.EQUAL,
      },
      {
        quick: false,
        name: 'clubes_involucrados',
        type: TYPES.INPUT,
        placeholder: t('Club involucrado'),
        operator: OPERATORS.CONTAINS,
      },
    ];

    // if (user.isClubUser()) {
    //   ret = removeFilters(ret, ['club', 'fed_denominacion']);
    // }

    // if (user.isFederationUser()) {
    //   ret = removeFilters(ret, ['fed_denominacion']);
    // }
    return ret;
  }, []);
  return (
    <PlanillaPartidoProgramadoGridList
      changeBlockUI={changeBlockUI}
      baseUrl={baseUrl}
      quickFilters={quickFilters}
      onItemClick={onItemClick}
      onClickCardMode={() => setMode(CARD_MODE)}
      onClickGridMode={() => setMode(GRID_MODE)}
      mode={mode}
      courier={courier}
      keyList={'PlanillaPartidoProgramadoGridList'}
    ></PlanillaPartidoProgramadoGridList>
  );
};
